<template>
  <div>
    <div class="dashboard-title">{{ $t("dashboard.stripe.linkTitle") }}</div>
    <hr />
    <div class="recharge-steps" v-if="step == 1">
      <div class="stripe-logo">
        <img src="../../assets/Stripe_Logo.png" alt="Stripe Logo" />
      </div>
      <div class="login-form">
        <p>{{ $t("dashboard.stripe.login") }}</p>
        <div class="alert alert-danger w-100 py-1" role="alert" v-if="showErr">
          {{ err }}
        </div>
        <input
          required
          type="text"
          id="username"
          v-model="username"
          :placeholder="$t('dashboard.stripe.username')"
        />
        <input
          required
          type="password"
          id="password"
          v-model="password"
          :placeholder="$t('dashboard.stripe.password')"
        />
        <div class="btn btn-gold btn-block text-white" @click="linkStripe">
          {{ $t("dashboard.stripe.link") }}
        </div>
        <span>{{ $t("dashboard.stripe.reminder") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      step: 1,
      username: null,
      password: null,
      showErr: false,
      err: "",
    };
  },
  mounted() {},
  methods: {
    linkStripe() {
      if (!this.username || !this.password) {
        this.err = this.$t("dashboard.stripe.err");
        this.showErr = true;
        return;
      }
      alert(this.username)
    },
  },
  watch: {
    username: function () {
      if (this.username && this.password) this.showErr = false;
    },
    password: function () {
      if (this.username && this.password) this.showErr = false;
    },
  },
};
</script>

<style>
.recharge-steps {
  .login-form {
    box-shadow: 0px 4.4px 22px 0px #0000000d;
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 1.5rem;
    padding: 2rem;
    max-width: 436px;
    margin: 1rem auto;
    p {
      text-align: center;
      width: 100%;
      color: #3b3e51;
      font-size: 1rem;
      font-weight: 400;
      margin: 0;
    }
    input {
      display: block;
      width: 100%;
      border: none;
      border-radius: 1rem;
      background-color: #f4f9fe;
      padding: 0.5rem 1.5rem;
    }
    .btn-block {
      width: 100%;
      font-size: 1.5rem;
      font-weight: 700;
    }
    span {
      color: #808695;
      font-size: 0.85rem;
    }
  }
}
</style>
